/**
 * @fileoverview PUT handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/details" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdDetailsCacheKeys } from "./constants";
import type {
  PutDecisioningStudioAgentsAppGroupIdDsaIdDetailsProps,
  PutDecisioningStudioAgentsAppGroupIdDsaIdDetailsResult,
} from "./types";

export const putDecisioningStudioAgentsAppGroupIdDsaIdDetails = reactQueryMutationAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdDetailsCacheKeys,
  (
    props: PutDecisioningStudioAgentsAppGroupIdDsaIdDetailsProps
  ): Promise<PutDecisioningStudioAgentsAppGroupIdDsaIdDetailsResult> => {
    return fetch(`/decisioning_studio_agents/${props.appGroupId}/${props.dsaId}/details`, "PUT", {
      name: props.name,
      ...(props.description !== undefined ? { description: props.description } : {}),
    });
  }
);
